<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <div class='pin-left half-width'>
            <h1>Skeleton Tieup Search</h1>
        </div>
        <div class='pin-right reducer-right'>
           <b-button variant='primary'>Start Over</b-button>
        </div>

        <div class='clear-pins'>
            A skeleton tieup reduces the number of treadles required to weave a draft by sometimes using more than one treadle at once.  Not every draft has a skeleton tieup that can be found in a finite amount of time. When one can be
            located, sometimes a loom lacking enough treadles for the original tieup can still weave the same pattern.
        </div>
        <div class='top-padding'>                  
            This page will search for a skeleton tieup for rising shed looms, displaying the first one found which works on your loom or the best one found within five minutes.  
        </div>

        <mailChimpSignup/>
    </b-container>

</template>

<script>
import mailChimpSignup from './MailChimpSignup.vue'

export default {
    data() {
        return {
            currentState: 'initial',
            tieupShaftsCount: 2,
            tieupTreadlesCount: 2,
            targetTreadlesCount: 2
        }
    },
    components: {
        mailChimpSignup: mailChimpSignup
    },

    methods: {

    },

    created() {
        this.$store.commit('setPageTitle', 'Skeleton Tieup Search Treadle Reducer')
    }
}
</script>

<style scoped>
.reducer-inline {
    display: inline-block;
}

.reducer-right {
    text-align: right;
}

.pin-left {
    float: left
}

.pin-right {
    float: right
}

.clear-pins {
    clear: both
}
</style>



// WEBPACK FOOTER //
// src/components/TreadleReducer.vue